// extracted by mini-css-extract-plugin
module.exports = {"form":"TagForm_form__2pl4d","containerButtons":"TagForm_containerButtons__3sOJm"};